<template>
  <div :class="$style.headerOutside">
    <h2 :class="$style.titleOutside">{{ t('neighbourhood.insights.title') }}</h2>
    <span :class="$style.aiBadge">
      <span :class="$style.badgeText">{{ t('neighbourhood.insights.aiPowered') }}</span>
    </span>
    <HgTooltip :class="$style.inlineTooltip" @click="handleTooltipClick">
      <div :class="$style.tooltipContent">
        <h3>{{ t('neighbourhood.insights.tooltip.title') }}</h3>
        <p>{{ t('neighbourhood.insights.tooltip.description') }}</p>
      </div>
    </HgTooltip>
  </div>
</template>
<script setup lang="ts">
import { HgTooltip } from '@smg-real-estate/domus';
import { useI18n } from 'vue-i18n';
import { trackNeighbourhoodTooltipOpen } from './neighbourhood.tracking';

defineOptions({
  name: 'NeighbourhoodHeader',
});

const { t } = useI18n();

const handleTooltipClick = (): void => {
  trackNeighbourhoodTooltipOpen();
};
</script>

<style module lang="scss">
@import '@/assets/variables';

.headerOutside {
  display: flex;
  align-items: center;
  gap: 16px;
}

.titleOutside {
  font-size: 22px;
  font-weight: 800;
  color: #333333;
  margin: 0;
  line-height: 33px;
}

.aiBadge {
  display: inline-flex;
  align-items: center;
  gap: 0;
  padding: 1px 8px;
  background: linear-gradient(62.8deg, #d3ecff 1.35%, #ccffe2 97.06%);
  color: #111111;
  border-radius: 4px;
}

.badgeText {
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 22px;
}

.inlineTooltip {
  display: inline-flex;
  align-items: center;
}

.tooltipContent {
  h3 {
    margin: 0 0 0.5rem 0;
    font-weight: 600;
  }

  p {
    margin: 0;
  }
}
</style>
